import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const BASE_URL = `${API_CONFIG.BASE_URL}/companies`;

export const websiteSettingsService = {
  // Get current company website settings
  getWebsiteSettings: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/settings/website`, {
        headers: getAuthHeader()
      });
      return response.data.settings || {};
    } catch (error) {
      console.error('Error fetching website settings:', error);
      throw error;
    }
  },

  // Update website settings
  updateWebsiteSettings: async (settings) => {
    try {
      const response = await axios.put(`${BASE_URL}/settings/website`, settings, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating website settings:', error);
      throw error;
    }
  }
};

export default websiteSettingsService;

